import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withMountListener } from '@beef/react/enhancers';
import { compose } from '@beef/utils';
import classNames from 'classnames/bind';
import { useIsMobileDimension } from '@beef/elk-common/hooks';
import { selectInitData } from "../../../store/selectors";
import { selectTariff } from "./store/selectors";
import { ConnectionBlockActionCreator } from "./store/actions";
import { Card } from "../Card";
import { Balance, GroupBanner, MobileTariff } from "./components";
import { SpecialTariffType } from "./constants/enums";
import { FTTBTariff } from "./components/FTTBTariff";
import { ConvergentTariff } from "./components/ConvergentTariff";
import { ActionCreatorTariff } from "./store/action/tariffActions";
import styles from "./styles.pcss";
import { Mobile } from "./Mobile";
var cn = classNames.bind(styles);
var _ConnectionBlock = function _ConnectionBlock(_ref) {
  var specialTariff = _ref.specialTariff,
    fetchConnectionPower = _ref.fetchConnectionPower,
    fetchConnectionSuperPower = _ref.fetchConnectionSuperPower,
    fetchConnectionData = _ref.fetchConnectionData,
    isInitDataLoaded = _ref.isInitDataLoaded;
  useEffect(function () {
    if (isInitDataLoaded) {
      fetchConnectionData();
    }
  }, [fetchConnectionData, isInitDataLoaded]);
  useEffect(function () {
    if (specialTariff === SpecialTariffType.TariffUp) {
      fetchConnectionPower();
      fetchConnectionSuperPower();
    }
  }, [specialTariff]);
  var isMobile = useIsMobileDimension();
  return /*#__PURE__*/React.createElement("div", {
    className: cn('block-container'),
    "data-t-id": "Container-ConnectionBlock"
  }, /*#__PURE__*/React.createElement(Card, {
    className: cn({
      wrapper: isMobile
    }),
    color: "secondary",
    hasPaddings: false
  }, /*#__PURE__*/React.createElement(Balance, {
    "data-t-id": "Container-ConnectionBlock"
  }), /*#__PURE__*/React.createElement(MobileTariff, null), /*#__PURE__*/React.createElement(FTTBTariff, null), /*#__PURE__*/React.createElement(ConvergentTariff, null), /*#__PURE__*/React.createElement(Mobile, null), /*#__PURE__*/React.createElement(GroupBanner, null)));
};
var mapStateToProps = function mapStateToProps(state) {
  var _selectTariff;
  return {
    specialTariff: (_selectTariff = selectTariff(state)) === null || _selectTariff === void 0 ? void 0 : _selectTariff.specialTariffType,
    isInitDataLoaded: !!selectInitData(state)
  };
};
var mapDispatchToProps = {
  fetchConnectionData: ActionCreatorTariff.onMountTariff,
  fetchConnectionPower: ConnectionBlockActionCreator.fetchConnectionPower,
  fetchConnectionSuperPower: ConnectionBlockActionCreator.fetchConnectionSuperPower
};
export var ConnectionBlock = compose(connect(mapStateToProps, mapDispatchToProps), withMountListener)(_ConnectionBlock);